import { combineReducers } from 'redux';
import dark from './dark'
export default combineReducers({
  dark
});